import React from 'react';
import { Client } from '../prismic-configuration';
import { PageWrapper } from '../components/base';
import Prismic from '@prismicio/client';
import { PrismicGrants, PrismicGrantItems } from '../types/prismic';
import { Grants, LandingHeader } from '../components/grants';
import getConfig from 'next/config';
const { serverRuntimeConfig } = getConfig();

interface Props {
  doc: PrismicGrants;
  items: PrismicGrantItems;
}

const PAGE_SIZE = 10;

const GrantsPage = ({ doc, items }: Props) => {
  return (
    <PageWrapper title={doc.data.header}>
      <LandingHeader data={doc} />
      <Grants grants={items ? items.results : null} />
    </PageWrapper>
  );
};

export async function getServerSideProps() {
  const client = Client();
  const doc = (await client.getSingle('grants', {})) as PrismicGrants;

  const predicates = [Prismic.Predicates.at('document.type', 'award')];

  if (serverRuntimeConfig.ONLY_SHOW_PROD_AWARDS) {
    predicates.push(
      Prismic.Predicates.at('my.award.visible_in_production', true)
    );
  }

  const items = await client.query(predicates, {
    pageSize: PAGE_SIZE,
    fetch: [
      'award.header_label',
      'award.award_process_active',
      'award.header_image',
      'award.cta_short',
      'award.url_slug',
    ],
    // fetchLinks: 'gift-guide-category.uid',
    orderings: '[my.award.order]',
  });
  // console.log(JSON.stringify(items, null, 2));

  return {
    props: {
      doc,
      items,
    },
  };
}

export default GrantsPage;
